<template>
  <div class="component-wrapper">
    <!-- <button @click="$emit('trigger-nav-link', 'main')">exit</button> -->
    <!-- <button @click="confirmNull()">I Don't Know</button> -->
    <h4 
      v-for="(t,i) in texts" 
      :key="i" 
      :style="{ fontSize:fontsize }" 
      class="newfont"
      style="text-align:center">{{ t }}</h4>
    <div class="flex">
      <div class="input-wrapper">
        <input 
          :id="inputId"
          class="charInput newfont" 
          v-model="inputValue" 
          :placeholder="placeholder" 
          :maxLength="maxLength">
        <div class="red" v-if="valueError">Required: {{inputError}}</div>
        <div class="underline"></div>
      </div>
    </div>
    <br />
    <div class="nav-flex">
      <button class="button-std newfont" @click="backstep"><span class="material-icons">chevron_left</span>Back</button>
      <button class="button-std newfont" @click="nextstep">Next<span class="material-icons">chevron_right</span></button>
    </div>
  </div>
</template>

<script>

const verify = {
  'minLength':function(obj,value){
    if(obj.minLength >= value.length){
      return `value is not above minimum length ${obj.minLength}`
    }
    return true;
  },
  'pattern':function(obj, value){
    let emailFormat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    switch(obj['pattern']){
      case "email":
        if(value.match(emailFormat)){
          return true;
        }
        return "Invalid Email"
      default:
        return "Error No case match"
    }
  },
  'chars':function(obj,value){
    let charsOk = value.split("").every(c => obj['chars'].indexOf(c) >= 0);
    if(charsOk === true){
      return true;
    }
    return `invalid character possible characters: ${obj['chars']}`
  },
  'limit':function(value,char,limit){
    let count = value.split("").reduce((acc,cv) => cv === char ? acc+=1 : acc, 0);
    if(count > limit){
      return `Error limit ${limit} exceeded for character ${char}`
    }
    return true;

  },
  'limitchars':function(obj,value){
    let { limitchars, limit } = obj
    let result = limitchars.map(c => {
      return this.limit(value,c,limit)
    }).find(x => typeof(x) === "string")
    if(result === undefined){
      return true;
    }
    return result;
  },
  'maxLength':function(obj,value){
    if(obj.maxLength >= value.length){
      return true;
    }
    return `value is above maximum length ${obj.maxLength}`
  },
  'whitespace':function(obj,value){
    let isspace = value.split("").indexOf(" ") >= 0;
    if(isspace === true){
      return "Cannot have spaces, please remove empty spaces";
    }
    return true;
  }
}
const verifier = (arr, value) => {
  return arr.reduce((acc,cv) => {
    if(typeof(acc) === "string"){
      return acc;
    }
    let key = Object.keys(cv)[0]
    if(verify[key] !== undefined){
      acc = verify[key](cv,value)
    }
    return acc;
  },true)
}
export default {
  name:"textInput",
  components:{

  },
  props:{
    verify: {
      type: Array,
      default: function(){
        return []
      }
    },
    showNext: {
      type: Boolean,
      default: true
    },
    showBack: {
      type: Boolean,
      default: true
    },
    showExit: {
      type: Boolean,
      default: false
    },
    fontsize: {
      default:"1em",
      type:String
    },
    placeholder:{
      type:String,
      default:"James",
    },
    maxLength:{
      type:String,
      default:"20",
    },
    backto: {
      type:Number
    },
    goto: {
      type:Number
    },
    for: {
      type:String,
      default:"None"
    },
    texts: {
      type:Array,
      default: function(){
        return []
      }
    },
    event_order:{
      type:Number
    },
    currentFrame:{
      type:Number
    },
  },
  data(){
    return {
      valueError:false,
      inputError:"",
      inputValue:"",
      errors: [],
      showConfirmPrompt: false,
      confirmMessage:""
    }
  },
  computed:{
    inputId:function(){
      return `${this.for}${this.event_order}`
    },
    newpin: function(){
      return this.char1+this.char2+this.char3+this.char4
    }
  },
  watch: {
    currentFrame:function(){
      if(this.currentFrame === this.event_order){
        setTimeout(() => {
          //console.log(this.inputId);
          let el = document.getElementById(this.inputId);
          el.focus()
        },1500)
      }
    }
  },
  methods:{
    nextstep(){
      //localStorage.setItem('pin', JSON.stringify(this.newpin))
      //console.log(this.verify);
      //console.log(this.inputValue);
      let out = verifier(this.verify,this.inputValue)
      //console.log(out);
      if(out === true){
        this.$emit('nextstep', {for:this.for, stepVal:this.goto, val:this.inputValue})
      } else {
        this.valueError = true;
        this.inputError = out
        setTimeout(() => {
          this.valueError = false;
          this.inputError = ""
        },9000)
      }
    },
    backstep(){
      this.$emit('backstep', {for:this.for, stepVal:this.backto})
    },
    confirmNull(){
      this.showConfirmPrompt = true;
    },
    changeInput(){

    },
  },
  beforeCreate(){
          // console.log('nothing gets created before me')
  },
  created(){

  },
  beforeMount(){

  },
  mounted(){
    document.appObserver.register('resetTextInput', () => {
      this.inputValue = ""
    });
  },
  beforeUpdate(){

  },
  updated(){

  },
  beforeDestroy(){

  },
  destroyed(){

  }
}

</script>

<style scoped>
.flex {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}
.box {
    box-sizing: border-box;
    cursor: pointer;
}
.input-wrapper {
  margin: 0px 0.5em;
}
.red {
  color:red;
}

.newfont {
  font-family:'Varela Round';
}
.button-std {
  background-color:#325DFF;
  color:#fff;
  font-weight:600;
  padding: 10px 20px;
  border-radius:9px;
  cursor:pointer;
  display:flex;
  align-items:center;
  cursor:pointer;
}
.charInput {
  font-size:3em;
  padding:10px;
  width:100%;
}
.nav-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items:center;
}
@media only screen and (max-width: 600px) {
  .charInput {
    font-size:1.6em;
    width:85%;
  }
}
</style>
